export const ID_FILTER_PRINTOUT_TYPE = "printout-type";
export const ID_FILTER_ACRISS = "acriss";
export const ID_FILTER_SIPP = "sipp";
export const ID_FILTER_EVENT_TYPE = "settings-type";
export const ID_FILTER_VALUE_RATE_FROM = 'value-rate-from';
export const ID_FILTER_VALUE_RATE_TO = 'value-rate-to';
export const ID_FILTER_FROM_KM = 'from-km';
export const ID_FILTER_TO_KM = 'to-km';